import React, { ReactNode } from "react";

import { Helmet } from "react-helmet";
import isSquare from "Square/isSquare";

import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";
import { ThemeProvider } from "Theme/Context";

const branding = isSquare() ? "square" : "default";

interface Props {
  title: string;
  children?: ReactNode;
  headerContent?: ReactNode;
}
const Chrome = ({ children, title, headerContent }: Props) => {
  const renderNavBar = () => {
    return <ResponsiveTopBar branding={branding} collapseOnSelect={false} />;
  };

  return (
    <ThemeProvider cobalt>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />
        {renderNavBar()}
        {headerContent && (
          <Grid mt={5} p={0}>
            {headerContent}
          </Grid>
        )}
        <Div style={{ flex: 1 }}>
          <Grid>{children}</Grid>
        </Div>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Chrome;
